function iqxWebBuildCandidateMenu(menu) {
  'use strict';

  menu.addItem({
    id: 'iqxWeb_menu_home',
    title: 'Home',
    icon: 'fas fa-home',
    url: '/home'
  })

  menu.addItem({
    id: 'iqxWeb_menu_diary',
    title: 'Diary',
    icon: 'fas fa-calendar',
    url: '/canddiary',
    rights: 'DIARY'
  })

  menu.addItem({
    id: 'iqxWeb_menu_shifts',
    title: 'Shifts',
    icon: 'far fa-building',
    url: '/shifts',
    switches: 'SHOWSHIFTS'
  })

  menu.addItem({
    id: 'iqxWeb_menu_references',
    title: 'References',
    icon: 'fas fa-pen-square',
    url: '/approvewebreferences',
    switches: 'SHOWWEBREFS'
  })

  menu.addDropdown({
    id: 'iqxWeb_menu_timesheets',
    title: 'Timesheets',
    icon: 'fas fa-building',
  }).subMenu
    .addItem({
      id: 'iqxWeb_menu_current',
      title: 'Current',
      url: '/provtimesheets/fill',
      rights: 'FILLTIMESHEETS'
    })
    .addItem({
      id: 'iqxWeb_menu_completed',
      title: 'Completed',
      url: '/timesheets'
    })

  menu.addDropdown({
    id: 'IqxWeb_menu_pay_documents',
    title: 'Pay Documents',
    icon: 'fas fa-money-check',
    rights: 'CANDIDATEPAYSLIPS'
  }).subMenu.addItem({
    id: 'iqxWeb_menu_payslips',
    title: 'Payslips',
    icon: 'fas fa-list',
    url: '/candidatepayslips',
    switches: 'PAYSLIPS'
  }).addItem({
    id: 'iqxWeb_menu_payslips2',
    title: 'Payslips',
    icon: 'fas fa-list',
    url: '/payslips',
    switches: 'ITSCSV'
  }).addItem({
    id: 'iqxWeb_menu_p60',
    title: 'p60',
    icon: 'fas fa-list',
    url: '/p60',
    switches: 'ITSCSV'
  }).addItem({
    id: 'iqxWeb_menu_p45',
    title: 'p45',
    icon: 'fas fa-list',
    url: '/p45',
    switches: 'ITSCSV'
  }).addItem({
    id: 'iqxWeb_menu_staffology_payslips',
    title: 'Payslips',
    icon: 'fas fa-list',
    url: '/staffologypayslips',
    switches: 'STAFFOLOGYPAYSLIPS'
  })

  menu.addDropdown({
    id: 'iqxWeb_menu_jobs',
    title: 'Jobs',
    icon: 'fas fa-search',
    switches: 'JOBSEARCH'
  }).subMenu
    .addItem({
      id: 'iqxWeb_menu_search',
      title: 'Search',
      url: '/jobsearch/advanced',
      rights: '!CANDHIDEJOBSPAGE'
    })
    .addItem({
      id: 'iqxWeb_menu_applied',
      title: 'Applied',
      url: '/jobsearch/applied',
      rights: '!CANDHIDEAPPLIEDJOBS'
    })

  menu.addItem({
    id: 'iqxWeb_menu_compliance',
    title: 'Compliance',
    icon: 'fas fa-check',
    url: '/candcompliance',
    rights: 'CANDCOMPLIANCE'
  })

  menu.addItem({
    id: 'iqxWeb_menu_documents',
    title: 'Personal Documents',
    icon: 'fas fa-file',
    url: '/canddocuments',
    rights: 'DOCCANDDOWNLOAD'
  })

  menu.addDropdown({
    id: 'IqxWeb_menu_details',
    title: 'Details',
    icon: 'fas fa-pencil-alt'
  }).subMenu.addItem({
    id: 'iqxWeb_menu_details',
    title: 'Personal Details',
    icon: 'fas fa-pencil-alt',
    url: '/canddetails',
    rights: '!CANDHIDEDETAILSPAGE'
  }).addItem({
    id: 'iqxWeb_menu_bankDetails',
    title: 'Bank Details',
    icon: 'fas fa-money-bill-alt',
    url: '/candidatebankdetails',
    rights: 'CANDBANKDETAILSVIEW'
  }).addItem({
    id: 'iqxWeb_menu_registration',
    title: 'Registration Details',
    icon: 'fas fa-briefcase',
    url: '/canddepartments',
    rights: 'CANDDEPTREG'
  })

  menu.addItem({
    id: 'iqxWeb_menu_downloads',
    title: 'Downloads',
    icon: 'fas fa-download',
    url: '/downloads',
    rights: '!CANDHIDEDOWNLOADSPAG'
  })

  menu.addItem({
    id: 'iqxWeb_menu_reports',
    title: 'Reports',
    icon: 'fas fa-chart-pie',
    url: '/reports',
    rights: 'MANAGEMENTINFO'
  })

  menu.addSplitter({
    id: 'iqxWeb_menu_splitter'
  })

  menu.addItem({
    id: 'iqxWeb_menu_settings',
    title: 'Settings',
    icon: 'fas fa-cog',
    url: '/settings'
  })

  menu.addItem({
    id: 'iqxWeb_menu_help',
    title: 'Help',
    icon: 'fas fa-question-circle',
    url: '/help',
    switches: 'SHOWFAQPAGE'
  })

  menu.addLogoutButton({
    id: 'iqxWeb_menu_logout',
    title: 'Logout',
    icon: 'fas fa-sign-out-alt',
    click: 'logout()',
    switches: 'CANDIDATE_LOGOUT_NAV'
  })

}
